import React from 'react';
import { Button } from '../UI';
import { ArrowLeft, Edit2, Trash2, Package, Calendar, Tag } from 'lucide-react';

const PantryDetailView = ({ item, onBack }) => {
  return (
    <div className="space-y-xl">
      {/* Header with Back Button */}
      <div className="flex items-center gap-md mb-lg">
        <button
          onClick={onBack}
          className="w-10 h-10 rounded-full bg-surface border border-text-tertiary/20 hover:border-primary/30 hover:bg-primary/5 flex items-center justify-center transition-all"
        >
          <ArrowLeft size={20} className="text-primary" />
        </button>
        <div className="flex-1">
          <h1 className="text-display font-rounded text-primary">Product Details</h1>
        </div>
        <Button
          variant="outline"
          icon={<Edit2 size={18} />}
        >
          Edit
        </Button>
        <Button
          variant="outline"
          icon={<Trash2 size={18} />}
        >
          Remove
        </Button>
      </div>

      {/* Product Info Card - Soft Design */}
      <div className="p-xl rounded-large bg-surface border border-text-tertiary/10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-xl">
          {/* Left - Image */}
          <div className="aspect-square rounded-large bg-gradient-to-br from-accent/5 to-primary/5 border border-text-tertiary/5 flex items-center justify-center overflow-hidden">
            {item?.imageURL ? (
              <img 
                src={item.imageURL} 
                alt={item.name}
                className="w-full h-full object-contain p-lg"
              />
            ) : (
              <Package size={64} className="text-text-tertiary" />
            )}
          </div>

          {/* Right - Details */}
          <div className="space-y-lg">
            <div>
              <h2 className="text-title-1 font-rounded text-primary mb-sm">
                {item?.name || 'Product Name'}
              </h2>
              <p className="text-callout text-text-secondary">
                {item?.brand || 'Brand'}
              </p>
            </div>

            {/* Info Grid */}
            <div className="space-y-md">
              <div className="flex items-center gap-md p-md rounded-large bg-gradient-to-br from-surface to-primary/5 border border-text-tertiary/5">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                  <Calendar size={16} className="text-primary" />
                </div>
                <div>
                  <p className="text-caption text-text-tertiary">Added Date</p>
                  <p className="text-callout font-semibold text-primary">
                    {item?.addedAt ? new Date(item.addedAt).toLocaleDateString() : 'N/A'}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-md p-md rounded-large bg-gradient-to-br from-surface to-accent/5 border border-text-tertiary/5">
                <div className="w-8 h-8 rounded-full bg-accent/10 flex items-center justify-center">
                  <Tag size={16} className="text-accent" />
                </div>
                <div>
                  <p className="text-caption text-text-tertiary">Category</p>
                  <p className="text-callout font-semibold text-primary">
                    {item?.category || 'Uncategorized'}
                  </p>
                </div>
              </div>
            </div>

            {/* Description */}
            {item?.description && (
              <div className="p-md rounded-large bg-gradient-to-br from-surface to-success/5 border border-text-tertiary/5">
                <p className="text-caption text-text-tertiary mb-xs">Description</p>
                <p className="text-body text-text-primary">
                  {item.description}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Additional Info - Soft Design */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-lg">
        <div className="p-lg rounded-large bg-surface border border-text-tertiary/10">
          <h3 className="text-callout font-semibold text-primary mb-md">
            Nutrition Info
          </h3>
          <p className="text-caption text-text-secondary">
            Nutrition information coming soon
          </p>
        </div>

        <div className="p-lg rounded-large bg-surface border border-text-tertiary/10">
          <h3 className="text-callout font-semibold text-primary mb-md">
            Dietary Tags
          </h3>
          <div className="flex flex-wrap gap-sm">
            {item?.dietaryTags?.length > 0 ? (
              item.dietaryTags.map((tag, index) => (
                <span
                  key={index}
                  className="px-md py-sm bg-primary/10 text-primary text-caption rounded-full border border-primary/20"
                >
                  {tag}
                </span>
              ))
            ) : (
              <p className="text-caption text-text-secondary">No dietary tags</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PantryDetailView;
